import React, { memo } from 'react';
import cls from './Option.module.css';
import classNames from 'classnames';

interface OptionProps {
    option: { name: string; avatar_url: string; id: number };
    // option: { value: string; title: string };
    onClick: (option: { name: string; avatar_url: string; id: number }) => void;
    CheckedStatusAddon?: React.ReactNode;
    isDisabled?: boolean;
    styles?: string;
}

export const Option = memo(
    ({ option, onClick, CheckedStatusAddon, isDisabled, styles = '' }: OptionProps) => {
        const handleClick = (event: React.MouseEvent) => {
            event.stopPropagation();
            onClick(option);
        };

        return (
            <li
                className={classNames(cls.option, styles, !option.id && cls.disabledOption)}
                onClick={handleClick}
            >
                {CheckedStatusAddon && !isDisabled && CheckedStatusAddon}
                <span
                    className={classNames(cls.optionTitle, [cls.optionSpan], {
                        [cls.notPicked]: option.id === null,
                    })}
                >
                    {option.name}
                </span>
            </li>
        );
    }
);
